import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { talentApi } from '../../../api/talent.js';

/**
 * Calibration sessions list + create. Each session links to its 9-box grid.
 */
export default function Calibration() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showCreate, setShowCreate] = useState(false);

  function refresh() {
    setLoading(true);
    talentApi
      .listSessions()
      .then((s) => setSessions(s?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function createSession(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    try {
      await talentApi.createSession({ name: fd.get('name') });
      e.target.reset();
      setShowCreate(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create session');
    }
  }

  return (
    <section data-testid="talent-calibration-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>9-Box Calibration</h1>
          <p className="muted">{sessions.length} sessions</p>
        </div>
        <button className="btn primary" data-testid="talent-calibration-create" onClick={() => setShowCreate((s) => !s)}>
          {showCreate ? 'Close' : '+ Session'}
        </button>
      </header>

      {error && <div className="alert error" data-testid="talent-calibration-error">{error}</div>}

      {showCreate && (
        <form onSubmit={createSession} className="card form-card grid-form">
          <label className="full">Name<input name="name" data-testid="talent-calibration-name-input" required /></label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="talent-calibration-submit">Create session</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="talent-calibration-list">
          <thead><tr><th>Session</th><th>Department</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {sessions.map((s) => (
              <tr key={s.id} data-testid={`talent-calibration-row-${s.id}`}>
                <td>{s.name}</td>
                <td>{s.department_name || '—'}</td>
                <td><span className="chip" data-testid={`talent-calibration-status-${s.id}`}>{s.status}</span></td>
                <td><Link className="btn ghost" data-testid={`talent-calibration-open-${s.id}`} to={`/talent/calibration/${s.id}`}>Open grid</Link></td>
              </tr>
            ))}
            {!loading && sessions.length === 0 && <tr><td colSpan={4} className="muted">No sessions yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
